import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, setToken, getToken } from "./api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [permissions, setPermissions] = useState([]);
  const [menuIds, setMenuIds] = useState(null); const [menuUrutan, setMenuUrutan] = useState([]);
  const [ready, setReady] = useState(false);
  const loadMenus = useCallback(() => api.get("/pengaturan/menu-saya").then((r) => { setMenuIds(r.data.menu_ids); setMenuUrutan(r.data.urutan || []); }).catch(() => setMenuIds(null)), []);

  useEffect(() => {
    if (!getToken()) { setReady(true); return; }
    api.get("/auth/me")
      .then((r) => { setUser(r.data.user); setPermissions(r.data.permissions); loadMenus(); })
      .catch(() => { setToken(null); setUser(null); })
      .finally(() => setReady(true));
  }, [loadMenus]);

  const login = useCallback(async (identifier, password) => {
    const r = await api.post("/auth/login", { identifier, password });
    setToken(r.data.access_token);
    setUser(r.data.user);
    setPermissions(r.data.permissions);
    loadMenus();
    return r.data.user;
  }, [loadMenus]);

  const logout = useCallback(async () => {
    try { await api.post("/auth/logout"); } catch (e) { /* token mungkin sudah tidak valid */ }
    setToken(null); setUser(null); setPermissions([]); setMenuIds(null);
  }, []);

  const can = useCallback((perm) => permissions.includes(perm), [permissions]);
  const menuAllowed = useCallback((id) => !id || menuIds === null || menuIds.includes(id), [menuIds]);

  return <AuthContext.Provider value={{ user, permissions, ready, login, logout, can, setUser, menuIds, menuUrutan, menuAllowed, reloadMenus: loadMenus }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);

export const ROLE_LABELS = { ADMIN: "Admin", SEKRETARIAT: "Sekretariat", KETUA_KOMISI: "Ketua Komisi", PIMPINAN: "Pimpinan", CARE_LEADER: "Care Leader", TIM_KUNJUNGAN: "Tim Kunjungan", MAJELIS_PENATALAYANAN: "Majelis Penatalayanan", KOORDINATOR_IBADAH: "Koordinator Ibadah", MAJELIS_PEMERHATI: "Majelis Pemerhati", MAJELIS_KOMISI_KOMSEL: "Majelis Komisi & Komsel", MAJELIS_ACARA_KHUSUS: "Majelis Acara Khusus", PETUGAS_PRESENSI: "Petugas Presensi", GURU_SM: "Guru SM", SEKRETARIS_KOMISI_ANAK: "Sekretaris Komisi Anak", MAJELIS_PENGAJARAN: "Majelis Pengajaran" };
// Multi-role: label gabungan semua role akun
export const roleLabelsOf = (u) => { const rs = [u?.role, ...(u?.roles || [])].filter((r, i, a) => r && a.indexOf(r) === i); return rs.map((r) => ROLE_LABELS[r] || r).join(" · "); };
